module.exports = __webpack_public_path__ + "img/sever-6.4192dedf.png";